/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Feedback_TitleInputs */

const en_us2_workout_after_feedback_title = /** @type {(inputs: Workout_After_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How did the session go?`)
};

const pt_br2_workout_after_feedback_title = /** @type {(inputs: Workout_After_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como foi a sessão?`)
};

const es_419_workout_after_feedback_title = /** @type {(inputs: Workout_After_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo te fue en la sesión?`)
};

const pt_pt2_workout_after_feedback_title = /** @type {(inputs: Workout_After_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como correu a sessão?`)
};

const fr_fr2_workout_after_feedback_title = /** @type {(inputs: Workout_After_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment s'est passée la séance ?`)
};

const de_de2_workout_after_feedback_title = /** @type {(inputs: Workout_After_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lief die Einheit?`)
};

const it_it2_workout_after_feedback_title = /** @type {(inputs: Workout_After_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com'è andata la sessione?`)
};

/**
* | output |
* | --- |
* | "How did the session go?" |
*
* @param {Workout_After_Feedback_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_feedback_title = /** @type {((inputs?: Workout_After_Feedback_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Feedback_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_feedback_title(inputs)
	if (locale === "es-419") return es_419_workout_after_feedback_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_feedback_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_feedback_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_feedback_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_feedback_title(inputs)
	return en_us2_workout_after_feedback_title(inputs)
});
export { workout_after_feedback_title as "workout-after.feedback_title" }